import { Component, Inject, NgModule } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { appConfig } from '@configuration/app-config'
import { Entity } from '@model/entities/entity'
import { DialogType } from '@type/dialog-type'
import { ShareButtonModule } from 'ngx-sharebuttons/button'
import { SharedModule } from 'src/app/shared.module'

@Component({
  selector: 'app-share-dialog',
  templateUrl: './share-dialog.component.html',
  styleUrls: ['./share-dialog.component.scss']
})
export class ShareDialogComponent {

  public appConfig = appConfig

  public text: string
  public buttons: any[]

  public static cssClass: DialogType = 'black-centered-dialog'

  public entity: Entity = null

  constructor(
    public dialogRef: MatDialogRef<ShareDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
  ) {
    this.entity = this.data.entity
    this.text = this.data.text
    this.buttons = this.data.buttons
  }

  public close(): void {
    this.dialogRef.close()
  }

}

@NgModule({
  declarations: [
    ShareDialogComponent,
  ],
  imports: [
    SharedModule,
    ShareButtonModule,
  ],
  exports: [
    ShareDialogComponent,

    SharedModule,
    ShareButtonModule,
  ]
})
export class ShareDialogComponentModule { }